import env from '../env';

/**
 * Environment-based Feature Flag Hook
 * 
 * This hook reads feature flags from environment variables
 * instead of using LaunchDarkly. Much simpler and more reliable!
 */
export const useFeatureFlags = () => {
  
  return {
    // Disbursement feature flag - controlled by environment variable
    isDisbursementFeatureEnabled: env.featureFlags.disbursementFeature,
    
    // Add more feature flags here as needed
    // Example: isNewUIEnabled: env.featureFlags.newUI,
    
    // For debugging - show all feature flags
    allFlags: {
      disbursementFeature: env.featureFlags.disbursementFeature,
      // Add more flags here
    },
  };
};